export enum VoucherErrorEnum {
  CANNOT_USE = 'cannot_use',
  ALREADY_USED = 'voucher_already_used',
  NOT_FOUND = 'voucher_not_found',
  ONLY_FOR_LOGGED_USER = 'only_for_logged_user',
  NO_ITEMS_TO_BE_USED_WITH_VOUCHER = 'no_items_to_be_used_with_voucher',
}
